<button mat-mini-fab class="m-1" color="primary" (click)="openStockLookupDialog()" matTooltip="Stock Lookup">
  <mat-icon>search</mat-icon>
</button>

<button mat-mini-fab class="m-1" color="primary" (click)="openQuickActionDialog()" matTooltip="Quick Action">
  <mat-icon>offline_bolt</mat-icon>
</button>

<button mat-mini-fab class="m-1" color="primary" (click)="openRegisterShoppingDialog()" matTooltip="Register Shopping">
  <mat-icon>shopping_cart</mat-icon>
</button>

<button mat-mini-fab class="m-1" color="primary" (click)="refreshCache()" matTooltip="Refresh Cache">
  <mat-icon>refresh</mat-icon>
</button>
